export default "__VITE_ASSET__bW8I6NxO__"